export default __webpack_public_path__ + "static/media/mcp-illustration.51a44385.webp";